import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { CreateAccountForm } from '../components/CreateAccountForm';
import getCSRFToken from '../general-utilities/getCsrfToken';
import { SessionService } from '../services/SessionService';
import { CreateAccountFormFields } from '../types/CreateAccountFormFields';

export const Signup = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState<CreateAccountFormFields>({
    firstName: '',
    lastName: '',
    callSign: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [errors, setErrors] = useState<Record<string, string>>({});

  const signUp = async () => {
    if (getCSRFToken() === null) {
      toast(t('signup_page.signup_failed'));
      toast.error('CSRF token not found');
      console.error('CSRF token not found');
      return;
    }

    try {
      const signUpResp = await SessionService.signup({
        email: formData.email,
        password: formData.password,
        first_name: formData.firstName,
        last_name: formData.lastName,
        username: formData.callSign
      });
      if (signUpResp && signUpResp.status !== 201) {
        throw new Error('Signup failed');
      }
      toast(signUpResp?.message);
    } catch (error) {
      console.error('Error signing up:', error);
      toast(t('signup_page.signup_failed'));
    }
  };

  return (
    <CreateAccountForm
      buttonText={t('signup_page.sign_up')}
      disableEmail={false}
      errors={errors}
      formData={formData}
      onSubmit={signUp}
      setErrors={setErrors}
      setFormData={setFormData}
    />
  );
};
